import 'css-chunksrc/client/scenes/costProfileEdition/form/styles.scss';export default {
  "form": "_form_19ws5_1",
  "group": "_group_19ws5_5",
  "row": "_row_19ws5_9",
  "label": "_label_19ws5_19",
  "description": "_description_19ws5_24"
};